import React from 'react';
import { Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { colors } from '@/globalStyles';
import { Icon, Label } from '@/components';
import { getMaterialWithLaserParameters } from '@/helpers';
import { pxcPortalApi } from '@/endpoints/apiUrls';
import CircleExclamationIcon from '@/icons/icon-circle-exclamation.svg';
import { ContextMenuStyled } from '../styles';

const LaserOutputContextMenu = () => {
  const intl = useIntl();
  const materialWithLaserParameters = getMaterialWithLaserParameters();

  if (materialWithLaserParameters.$1) {
    const href = pxcPortalApi.portalHome();

    return (
      <ContextMenuStyled sx={{ width: '365px', padding: '20px', fontFamily: 'SourceSansPro' }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, max-content)', alignItems: 'center', gap: '15px', mb: '15px' }}>
          <Box>
            <Icon src={CircleExclamationIcon} />
          </Box>
          <Box sx={{ fontSize: 16, color: colors.primary }}>
            <FormattedMessage id="cmme.laserOutputQuality.engraving" defaultMessage="Engraving" />
          </Box>
        </Box>

        <div style={{ color: colors.dimGray }}>
          <Label fontSize={14} fontFamily="SourceSansPro">
            <FormattedMessage
              id="cmme.laserOutputQuality.engraving.description"
              defaultMessage="cmme.laserOutputQuality.engraving.description"
            />
            <br/>
            <span>
              <span className="colon">
                <FormattedMessage id="cmme.laserOutputQuality.link" defaultMessage="Link" />
              </span>
              <a style={{ color: colors.primary }} href={href} target="_blank">
                {` ${intl.formatMessage({ id: 'cmme.laserOutputQuality.textLink', defaultMessage: 'Laser marking | Phoenix Contact' })}`}
              </a>
            </span>
          </Label>
        </div>
      </ContextMenuStyled>
    );
  }
  if (materialWithLaserParameters.$3) {
    return (
      <ContextMenuStyled sx={{ width: '365px', padding: '20px', fontFamily: 'SourceSansPro' }}>
        <div style={{ marginBottom: '15px' }}>
          <Label variant="bold" fontSize={16} fontFamily="SourceSansPro">
            <FormattedMessage id="cmme.laserOutputQuality" defaultMessage="Laser output quality" />
          </Label>
        </div>
        <Box sx={{ mb: '20px' }}>
          <Box
            sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, max-content)', alignItems: 'center', gap: '15px', mb: '10px' }}
          >
            <Box>
              <Icon src={CircleExclamationIcon} />
            </Box>
            <div style={{ color: colors.primary }}>
              <Label fontSize={14}>
                <FormattedMessage id="cmme.laserOutputQuality.engraving" defaultMessage="Engraving" />
              </Label>
            </div>
          </Box>
          <div style={{ color: colors.dimGray }}>
            <Label fontSize={14} fontFamily="SourceSansPro">
              <FormattedMessage
                id="cmme.laserOutputQuality.engraving.description"
                defaultMessage="cmme.laserOutputQuality.engraving.description"
              />
            </Label>
          </div>
        </Box>
        <Box sx={{ mb: '20px' }}>
          <Box
            sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, max-content)', alignItems: 'center', gap: '15px', mb: '10px' }}
          >
            <Box>
              <Icon src={CircleExclamationIcon} />
            </Box>
            <div style={{ color: colors.primary }}>
              <Label fontSize={14}>
                <FormattedMessage id="cmme.cutout" defaultMessage="Cutout" />
              </Label>
            </div>
          </Box>
          <div style={{ color: colors.dimGray }}>
            <Label fontSize={14} fontFamily="SourceSansPro">
              <FormattedMessage
                id="cmme.laserOutputQuality.engraving.description"
                defaultMessage="cmme.laserOutputQuality.engraving.description"
              />
            </Label>
          </div>
        </Box>
      </ContextMenuStyled>
    );
  }
  return null;
};

export default LaserOutputContextMenu;
